import { AxiosGlobal } from "../shared/axios";
import { AxiosPromise } from "axios";
import configs from "../../configs";
import { store } from "../../Components/store/store";
import { createApiHeaders, createPublicApiHeaders } from "../utils/apiHeaders";

export class DashboardLiveApi extends AxiosGlobal {

   

    uploadBankDoc(data: any): AxiosPromise<Array<any>> {
        return this.axios.post(`${configs.context}/dashboard/upload-bank-docs`, data, {
            headers: createApiHeaders()
        });
    }

    uploadKyc(data: any): AxiosPromise<Array<any>> {
        return this.axios.post(`${configs.context}/dashboard/kyc-verify`, data, {
            headers: createApiHeaders()
        });
    }

    applyStudentLoan(data: any): AxiosPromise<Array<any>> {
        return this.axios.post(`${configs.context}/dashboard/apply-student-loan`, data, {
            headers: createApiHeaders()
        });
    }


    createDynamicAccount(data: any): AxiosPromise<Array<any>> {
        return this.axios.post(`${configs.context}/payment/providus/create-dynamic-account`, data, {
            headers: createApiHeaders()
        });
    }



    makeSchoolPayment(data: any): AxiosPromise<Array<any>> {
        return this.axios.post(`${configs.context}/payment/make-school-payment`, data, {
            headers: createApiHeaders()
        });
    } 

    addSchool(data: any): AxiosPromise<Array<any>> {
        return this.axios.post(`${configs.context}/dashboard/add-school`, data, {
            headers: createApiHeaders()
        });
    }  

    getAllSchool(pageNo:any,query:any): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/dashboard/get-all-schools?page=${pageNo}&search=${query?.search}`,{
            headers: createApiHeaders()
          });
    } 

    getSchoolList(): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/dashboard/get-school-list`,{
            headers: createApiHeaders()
          });
    } 

    getPaymentHistory(pageNo:any,query:any): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/payment/payment-history?page=${pageNo}&search=${query?.search}`,{
            headers: createApiHeaders()
          });
    }

    getPendingPaymentHistory(): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/payment/pending-payment-history`,{
            headers: createApiHeaders()
          });
    }

    getPaymentDetail(id:any): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/payment/get-payment-details/${id}`,{
            headers: createApiHeaders()
          });
    }

    


    verifyLoan(): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/dashboard/verify-loan`,{
            headers: createApiHeaders()
          });
    }

    verifyKyc(): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/dashboard/verify-kyc`,{
            headers: createApiHeaders()
          });
    }
    getKycStatus(): AxiosPromise<Array<any>> {
        // console?.log(store.getState().data.login.value.token)
        return this.axios.get(`${configs.context}/kyc/status`,{
            headers: createApiHeaders()
          });
    }

    getVirtualAccount(currency: string): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.contextOld}/virtual-accounts/${currency}`,{
            headers: createApiHeaders()
          });
    }

    getWallets(currency: string): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.contextOld}/wallets/${currency}`,{
            headers: createApiHeaders()
          });
    }
    
    createWallet(data: { currency: string }): AxiosPromise<Array<any>> {
        return this.axios.post(`${configs.contextOld}/wallets`, data, {
            headers: createApiHeaders()
        });
    } 

    // NEW MAPLERAD METHODS
    getMapleradEnrollmentEligibility(): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.contextOld}/maplerad/enrollment/eligibility`,{
            headers: createApiHeaders()
          });
    }

    createMapleradVirtualAccount(): AxiosPromise<Array<any>> {
        return this.axios.post(`${configs.contextOld}/virtual-accounts/maplerad/ngn`, {}, {
            headers: createApiHeaders()
        });
    } 

    enrollCustomer(): AxiosPromise<Array<any>> {
        return this.axios.post(`${configs.contextOld}/maplerad/enrollment/enroll`, {}, {
            headers: createApiHeaders()
        });
    } 


    getVerificationDetails(): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/kyc/verification-details`,{
            headers: createApiHeaders()
          });
    }

    addressVerification(data: any): AxiosPromise<Array<any>> {
        return this.axios.post(`${configs.context}/kyc/address-verification`, data, {
            headers: createApiHeaders()
        });
    } 

    generalVerification(data: any): AxiosPromise<Array<any>> {
        return this.axios.post(`${configs.context}/kyc/general-verification`, data, {
            headers: createApiHeaders()
        });
    } 


    identityVerification(data: any): AxiosPromise<Array<any>> {
        return this.axios.post(`${configs.context}/kyc/identity-verification`, data, {
            headers: createApiHeaders()
        });
    } 

    updatePassword(data: any): AxiosPromise<Array<any>> {
        return this.axios.post(`${configs.contextOld}/update-password`, data, {
            headers: createApiHeaders()
        });
    } 
    
    updateProfilePicture(data: any): AxiosPromise<Array<any>> {
        return this.axios.post(`${configs.context}/kyc/upload-profile-picture`, data, {
            headers: createApiHeaders()
        });
    } 

    initiateUpdateTransactionPin(): AxiosPromise<Array<any>> {
        return this.axios.post(`${configs.contextOld}/transaction-pin/initiate-update`, {}, {
            headers: createApiHeaders()
        });
    }
    
    verifyTransactionPinOtp(data: { otp: string }): AxiosPromise<Array<any>> {
        return this.axios.post(`${configs.contextOld}/transaction-pin/verify-otp`, data, {
            headers: createApiHeaders()
        });
    }
    
    setNewTransactionPin(data: { pin: string, confirm_pin: string }): AxiosPromise<Array<any>> {
        return this.axios.post(`${configs.contextOld}/transaction-pin/set-new-pin`, data, {
            headers: createApiHeaders()
        });
    }

    verifyTransactionPin(data: { pin: string }): AxiosPromise<Array<any>> {
        return this.axios.post(`${configs.contextOld}/transaction-pin/verify`, data, {
            headers: createApiHeaders()
        });
    }

    
    createCard(data: any): AxiosPromise<Array<any>> {
        return this.axios.post(`${configs.contextOld}/cards`, data, {
            headers: createApiHeaders()
        });
    }

    getCardDetails(): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.contextOld}/cards/my-card/usd/details`,{
            headers: createApiHeaders()
          });
    } 

    freezeCard(): AxiosPromise<Array<any>> {
        return this.axios.patch(`${configs.contextOld}/cards/my-card/usd/freeze`, {}, {
            headers: createApiHeaders()
        });
    }
    
    unfreezeCard(): AxiosPromise<Array<any>> {
        return this.axios.patch(`${configs.contextOld}/cards/my-card/usd/unfreeze`, {}, {
            headers: createApiHeaders()
        });
    }

    getCardTransactions(page = 1, limit = 20): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.contextOld}/cards/my-card/usd/transactions?page=${page}&limit=${limit}`, {
            headers: createApiHeaders()
        });
    }
    

    fundCard(data: { amount: number }): AxiosPromise<any> {
        return this.axios.post(`${configs.contextOld}/cards/my-card/usd/fund`, data, {
            headers: createApiHeaders()
        });
    }

    withdrawFromCard(data: { amount: number }): AxiosPromise<any> {
        return this.axios.post(`${configs.contextOld}/cards/my-card/usd/withdraw`, data, {
            headers: createApiHeaders()
        });
    }

    deleteCard(): AxiosPromise<any> {
        return this.axios.delete(`${configs.contextOld}/cards/my-card/usd/terminate`, {
            headers: createApiHeaders()
        });
    }

    
    getCardSpendingUsage(): AxiosPromise<any> {
        return this.axios.get(`${configs.contextOld}/cards/my-card/usd/spending-usage`, {
            headers: createApiHeaders()
        });
    }
    getFxQuote(data: { source_amount: number; source_currency: string; target_currency: string }): AxiosPromise<any> {
        return this.axios.post(`${configs.contextOld}/fx/quote`, data, {
            headers: createApiHeaders()
        });
    }
    performFxSwap(data: { internal_reference: string }): AxiosPromise<any> {
        return this.axios.post(`${configs.contextOld}/fx/swap`, data, {
            headers: createApiHeaders()
        });
    }
    
    // getLatestRates(): AxiosPromise<any> {
    //     return this.axios.get(`${configs.contextOld}/fx/latest-rates`, {
    //         headers: createApiHeaders()
    //     });
    // }
    getLatestRates(data: { source_amount: number; source_currency: string; target_currency: string }): AxiosPromise<any> {
        return this.axios.post(`${configs.contextOld}/fx/latest-rates`, data, {
            headers: createApiHeaders()
        });
    }

    getLatestRatesOnWebsite(data: {source_amount: number, source_currency:string, target_currency:string}): AxiosPromise<any> {
        return this.axios.post(`${configs.contextOld}/fx/latest-rates`, data, {
            headers: createPublicApiHeaders()
        });
    }

    getAllRatesOnWebsite(): AxiosPromise<any> {
        return this.axios.get(`${configs.contextOld}/fx/all-rates`, {
            headers: createPublicApiHeaders()
        });
    }

    setDeleteAccount(data: { password: string, reason: string }): AxiosPromise<Array<any>> {
        return this.axios.post(`${configs.contextOld}/delete-account`, data, {
            headers: createApiHeaders()
        });
    }
    
    resendTransactionPinOtp(): AxiosPromise<Array<any>> {
        return this.axios.post(`${configs.contextOld}/transaction-pin/resend-otp`, {}, {
            headers: createApiHeaders()
        });
    }
    
    uploadProfilePicture(data: any): AxiosPromise<Array<any>> {
        return this.axios.post(`${configs.context}/kyc/upload-profile-picture`, data, {
            headers: createApiHeaders()
        });
    } 

    getUserProfile(): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.contextOld}/user/profile`,{
            headers: createApiHeaders()
          });
    } 

    getAllRates(): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.contextOld}/fx/all-rates`, {
            headers: createApiHeaders()
        });
    }

    makePayment(amount: any): AxiosPromise<Array<any>> {
        return this.axios.post(`${configs.context}/payment/make-payment`, amount, {
            headers: createApiHeaders()
        });
    } 


    makePaymentFromWallet(amount: any): AxiosPromise<Array<any>> {
        return this.axios.post(`${configs.context}/payment/make-school-payment-from-wallet`, amount, {
            headers: createApiHeaders()
        });
    } 

    makePaymentWithInterswitch(amount: any): AxiosPromise<Array<any>> {
        return this.axios.post(`${configs.context}/payment/make-payment-with-interswitch`, amount, {
            headers: createApiHeaders()
        });
    } 


    generateQuote(data: any): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/payment/flutterwave/get-exchange-rate?amount=${data?.amount}&from=${data?.from}&to=${data?.to}`, {
            headers: createApiHeaders()
        });
    } 

    swap(): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/payment/monieverse/swap`, {
            headers: createApiHeaders()
        });
    } 

    

    getCallback(reference: any): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/payment/callback?reference=${reference}`, {
            headers: createApiHeaders()
        });
    }  


    getDashboardData(): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/dashboard/get-dashboard-data`, {
            headers: createApiHeaders()
        });
    }  


    verifyInterswitchPayment(reference: any,amount:any): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/payment/verify-payment-with-interswitch?reference=${reference}&amount=${amount}`, {
            headers: createApiHeaders()
        });
    } 

    createCreditEligibility(data: any): AxiosPromise<Array<any>> {
        return this.axios.post(`${configs.contextOld}/credit-eligibility/create-credit-eligibility`, data, {
            headers: createApiHeaders()
        });
    } 

    getSingleCreditEligibity(id:any): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/credit-eligibility/get-single-credit-form/${id}`,{
            headers: createApiHeaders()
          });
    }

    createSchoolForm(data: any): AxiosPromise<Array<any>> {
        return this.axios.post(`${configs.contextOld}/credit-eligibility/create-school-form`, data, {
            headers: createApiHeaders()
        });
    } 

    applyStudyLoan(data: any): AxiosPromise<Array<any>> {
        return this.axios.post(`${configs.contextOld}/dashboard/apply-study-loan`, data, {
            headers: createApiHeaders()
        });
    } 
    admissionProcess(data: any): AxiosPromise<Array<any>> {
        return this.axios.post(`${configs.contextOld}/dashboard/admission-process`, data, {
            headers: createApiHeaders()
        });
    } 

    getSingleSchoolForm(id:any): AxiosPromise<Array<any>> {
        return this.axios.get(`${configs.context}/credit-eligibility/get-single-school-form/${id}`,{
            headers: createApiHeaders()
          });
    }

    


}